export const HOME_FOLDER_ID = 0;
export const TRASH_FOLDER_ID = 'trash';
export const HELD_FOLDER_ID = 'held';
export const PAUSED_FOLDER_ID = 'paused';

// This is the same shape as real folders that come from the server,
// except no `accountId` is present.
export const homeFolder = {
  id: HOME_FOLDER_ID, // this has been used throughout codebase
  isShared: false,
  title: 'Home',
  isVirtual: true,
  isHeld: false,
  sortOrder: 1,
};
